export default "__VITE_ASSET__CXww6U_Z__"